var _excluded = ["children", "className", "node"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import { Avatar } from "./Avatar.mjs";
import { SocialFields } from "./SocialFields.mjs";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Contact(_ref) {
  var {
      children,
      className,
      node
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var {
    contact,
    layout,
    show_avatar
  } = node;
  var jobDescription = [contact.description, contact.company].filter(Boolean).join(', ');
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    id: "contact-".concat(node.uuid),
    className: classNames('prezly-slate-contact', className, {
      'prezly-slate-contact--card': layout === 'card',
      'prezly-slate-contact--signature': layout === 'signature'
    })
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "prezly-slate-contact__wrapper",
      children: [show_avatar && /*#__PURE__*/_jsx(Avatar, {
        name: contact.name,
        src: contact.avatar_url
      }), /*#__PURE__*/_jsxs("div", {
        className: "prezly-slate-contact__content",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "prezly-slate-contact__name",
          children: contact.name
        }), /*#__PURE__*/_jsx("div", {
          className: "prezly-slate-contact__job-description",
          children: jobDescription || /*#__PURE__*/_jsx(_Fragment, {
            children: "\xA0"
          })
        }), /*#__PURE__*/_jsx(SocialFields, {
          className: "prezly-slate-contact__social-fields",
          contact: contact,
          layout: layout
        })]
      })]
    })
  }));
}